import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import HeaderFixed from './HeaderFixed';
import HeaderScrolling from './HeaderScrolling';
import HeaderCustom from './HeaderCustom';
import BrandLogo from './BrandLogo';
import TransitionChild from '../common/TransitionChild';
import '../../css/react-css-transitions.scss';
import { isValid, isText, decodeTags } from '../../utils';

export class Header extends Component {
  constructor() {
    super();
    this.state = {
      showScrollingHeader: false,
      logoClick: true,
    };

    this.handleScroll = this.handleScroll.bind(this);
    this.onLogoClick = this.onLogoClick.bind(this);
  }

  handleScroll() {
    const { showScrollingHeader } = this.state;
    const { scrollY } = window;

    if (scrollY > 0 && showScrollingHeader === false) {
      this.setState({
        showScrollingHeader: true,
      });
    }

    if (scrollY === 0 && showScrollingHeader === true) {
      this.setState({
        showScrollingHeader: false,
      });
    }
  }

  onLogoClick() {
    this.setState({
      logoClick: !this.state.logoClick,
    });
  }

  componentDidMount() {
    this.handleScroll();
    window.addEventListener('scroll', this.handleScroll);
  }

  render() {
    const { showScrollingHeader, logoClick } = this.state;
    const {
      isMobile, pageType, onMenuClick, articleHed, social, standardArticleTracker, articleHeader, category, heroImage, tags, hedUrl, seo, page, settings, sponsorship, verticalHomepage,
    } = this.props;
    
    const isCeros = (pageType === 'article' && isValid(settings.articleLayout) && settings.articleLayout === 'Ceros');
    const isSponsored = (pageType === 'article' && isValid(sponsorship) && sponsorship.articleType === 'Sponsored');
    const hasSponsorshipImg = (pageType === 'article' && isValid(sponsorship.sponsorshipImage) && (sponsorship.sponsorshipImage !== 0));
    const sponsorImage = (pageType === 'article' && hasSponsorshipImg) ? sponsorship.sponsorshipImage : null;
    const sponsorUrl = (pageType === 'article' && isValid(sponsorship.sponsorshipUrl)) ? sponsorship.sponsorshipUrl : null;

    const makeSponsorshipText = () => {
      let sponsorshipText = null;
      if (hasSponsorshipImg && !isValid(sponsorship.sponsorshipBannerOverride) && (!isMobile || (isMobile && isCeros))) {
        sponsorshipText = 'Sponsored By';
      } else if ((hasSponsorshipImg && (!isMobile || (isMobile && isCeros)) && isValid(sponsorship.sponsorshipBannerOverride)) || (!hasSponsorshipImg && isValid(sponsorship.sponsorshipBannerOverride))) {
        sponsorshipText = sponsorship.sponsorshipBannerOverride;
      } else if (!hasSponsorshipImg && !isValid(sponsorship.sponsorshipBannerOverride)) {
        sponsorshipText = 'Sponsored';
      }
      return sponsorshipText;
    };
    const renderedSponsorshipText = (pageType === 'article') && makeSponsorshipText();

    const HeaderMenuButton = <div className="header-icon header-icon-menu icon-menu-icon-desktop-nav" onClick={onMenuClick}/>;
    const HeaderLogo = <BrandLogo mark={false} onClick={this.onLogoClick} pageType={pageType} category={category} hidden={verticalHomepage}/>;
    const HeaderLogoMark = <BrandLogo mark={true} onClick={this.onLogoClick} pageType={pageType} category={category} />;
    const HeaderEmailButton = <div className="share header-icon header-icon-email" />;

    const renderSponsorLogo = () => {
      if (pageType === 'article' && isValid(sponsorship) && isSponsored && isCeros) {
        return (<div className="sponsored-container">
                  <span className="sponsored-text">{renderedSponsorshipText}</span>
                  {hasSponsorshipImg && <a href={sponsorUrl} className='sponsor-url' target='_blank'><img className='sponsored-logo' src={sponsorImage} /></a>}
                </div>
        );
      }
      return null;
    };

    const renderedSponsorLogo = (pageType === 'article') && renderSponsorLogo();

    // HeaderScrolling
    const renderedHeaderScrolling = (
      <HeaderScrolling
        HeaderMenuButton={HeaderMenuButton}
        HeaderLogo={HeaderLogo}
        HeaderLogoMark={HeaderLogoMark}
        articleHed={articleHed}
        isMobile={isMobile}
        social={social}
        category={category}
        heroImage={heroImage}
        tags={tags}
        hedUrl={hedUrl}
        seo={seo}
        isCeros={isCeros}
        renderedSponsorLogo={renderedSponsorLogo}
        />
    );

    const shouldShowScrollingHeader = showScrollingHeader;

    return (
      <Fragment>
        {shouldShowScrollingHeader ? (
          <div className='header scrolling'>
             <ReactCSSTransitionGroup
              key="global-header-scrolling"
              transitionName="fade"
              transitionEnterTimeout={500}
              transitionLeaveTimeout={500}
              component={TransitionChild}>
              {renderedHeaderScrolling}
            </ReactCSSTransitionGroup>
          </div>
         ) : (
          <div className='header'>
            <HeaderFixed
              isMobile={isMobile}
              HeaderLogo={HeaderLogo}
              HeaderLogoMark={HeaderLogoMark}
              HeaderMenuButton={HeaderMenuButton}
              standardArticleTracker={standardArticleTracker}
              category={category}
              logoClick={logoClick}
              page={page}
              verticalHomepage={verticalHomepage}
            />
          </div>
        )}
      </Fragment>
    );
  }
}


const mapStateToProps = ({
  isMobile, pageData, standardArticleTracker, page,
}) => {
  const { article=[], pageType=null, } = pageData;
  const isWowShop = (isValid(pageData) && isValid(pageData.page) && isValid(pageData.page[0]) && pageData.page[0].hedUrl === 'wowshop');
  const category = isValid(article[0]) ? article[0].category : (isValid(pageData.category) && pageData.category == 'article') ? '' : isValid(pageData.category) ? pageData.category : isWowShop ? 'wowshop' : null;
  const articleHed = (isValid(pageType) && pageType === 'article' && isValid(article[0])) ? article[0].headline : null;
  const sponsorship = (isValid(pageType) && pageType === 'article' && isValid(article[0])) ? article[0].sponsorship : null;
  const settings = (isValid(pageType) && pageType === 'article' && isValid(article[0])) ? article[0].settings : null;
  const social = (isValid(pageType) && pageType === 'article' && isValid(article[0])) ? article[0].social : null;
  const tags = (isValid(pageType) && pageType === 'article' && isValid(article[0])) ? article[0].tags : null;
  const heroImage = (isValid(pageType) && pageType === 'article' && isValid(article[0])) ? article[0].heroImage : null;
  const hedUrl = (isValid(pageType) && pageType === 'article' && isValid(article[0])) ? article[0].hedUrl : null;
  const seo = (isValid(pageType) && pageType === 'article' && isValid(article[0])) ? article[0].seo : null;
  const verticalHomepage = isValid(pageData) && pageType === "vertical" && !pageData.category;
  
  const getHeaderType = () => {
    if (pageType === 'article') {
      const { modules = [] } = article[0];
      const customModule = modules.filter(module => module.type === 'custom-content');
      return (customModule && customModule.length > 0);
    }
    return false;
  };

  const articleHeader = getHeaderType();

  return {
    isMobile,
    articleHed,
    sponsorship,
    settings,
    social,
    pageType,
    standardArticleTracker,
    articleHeader,
    category,
    tags,
    heroImage,
    hedUrl,
    seo,
    page,
    verticalHomepage
  };
};

const mapDispatchToProps = dispatch => ({
  onMenuClick: () => {
    dispatch({
      type: 'SIDEBAR_TOGGLE',
    });
  },
});

export const HeaderContainer = connect(mapStateToProps, mapDispatchToProps)(Header);

export default HeaderContainer;
